import {Action} from '@ngrx/store';
import {Site} from '../models/site';
import {type} from '../utilities/type';

export const mySitesActionTypes = {
  LOAD: type('[My Sites] Load'),
  LOAD_SUCCESS: type('[My Sites] Load Success'),
  LOAD_FAIL: type('[My Sites] Load Fail')
};

export class LoadMySitesAction implements Action {
  readonly type = mySitesActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadMySitesSuccessAction implements Action {
  readonly type = mySitesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Site[]) {}
}

export class LoadMySitesFailAction implements Action {
  readonly type = mySitesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
